import {SpinnerService} from "../../modules/SpinnerModule";
import {DataHubService} from "../../modules/DataHubModule";

export function CardMigrationController($dataHub: DataHubService, $spinner: SpinnerService) {
    var vm = this;

    vm.profiles = [];
    $spinner.show('Starting');
    $dataHub.client.onCustomerPaymentMigrationUpdated(e => vm.profiles.merge(e, x => x.guid));
    $dataHub.client.onCustomerPaymentMigrationRemoved(e => vm.profiles.remove(e, x => x.guid));

    vm.refresh = () => {
        $spinner.show('Loading');
        $dataHub.server.customerPaymentMigrationSub()
            .catch(handleError)
            .finally(() => $spinner.hide());
    };
    $dataHub.onConnected(vm.refresh);


    function handleError(e) {
        console.error(e);
        if (e.data && e.data.exceptionMessage) {
            vm.error = e.data.exceptionMessage;
        } else {
            vm.error = e;
        }
    }

    vm.save = function (profile) {
        $spinner.show('Saving');
        $dataHub.server.customerPaymentMigrationSave(profile)
            .catch(alert)
            .finally(() => $spinner.hide());
    };
    vm.remove = function (profile) {
        $spinner.show('Removing');
        $dataHub.server.customerPaymentMigrationRemove(profile)
            .catch(alert)
            .finally(() => $spinner.hide());
    };

    vm.getCardRegex = profile => {
        if (!profile.originalCard)
            profile.originalCard = profile.creditCardInfo.creditCardNumber.replace(/x+/,'');
        return '\\d{11,12}' + profile.originalCard;
    }

}
